export const paymentLinkReasons = [
  'EBSC_Booking',
  'EBSC_Childbooking',
  'EBSC_Exchange',
  'EBSC_MusicalInstrument',
  'EBSC_NameChange',
  'EBSC_PCIPal',
  'EBSC_SpecialOccassion',
  'ESS_Boxed_Bike',
  'ESS_Fully_Assemble_Bike',
  'ESS_Group_Luggage',
  'ESS_Lost_Property_Repatriation',
  'ESS_Luggage',
  'ESS_Oversized_Luggage',
  'ESS_Parcel',
  'ESS_Prohibited_Item',
  'ESS_VIP_Booking',
  'IDS_Payment'
];
